import { useState, useEffect, useRef } from 'react';
import FEMS from './FEMS';
import WeightSorting from './WeightSorting';
import { backgroundMainColor } from '../Color';
import Toggle from '../Toggle';

function JOFoodMonitoring() {
  const toggleLocalStorageKey = 'joFoodAutoChangeMonitoring';
  const monitoringArray = [<FEMS />, <WeightSorting />];
  const [monitoringIndex, setMonitoringIndex] = useState(0);
  const [autoChangeMonitoring, setAutoChangeMonitoring] = useState(localStorage.getItem(toggleLocalStorageKey) === 'true' || localStorage.getItem(toggleLocalStorageKey) === null);
  const autoChangeMonitoringRef = useRef(autoChangeMonitoring);
  
  useEffect(() => {
    document.title = 'JOFOOD MONITORING';

    const intervalId = setInterval(() => {
      if (autoChangeMonitoringRef.current) ChangeMonitoring();
    }, 1000 * 30);

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  },[]);

  function ChangeMonitoring() {
    setMonitoringIndex((previousIndex) => {
      return (previousIndex + 1) % monitoringArray.length
    });
  }

  useEffect(() => {
    autoChangeMonitoringRef.current = autoChangeMonitoring;
  }, [autoChangeMonitoring]);

  const buttonStyle = { 
    backgroundColor: backgroundMainColor, 
    color: 'rgb(204,204,204)', 
    border: 'none', 
    fontSize: 30, 
    width: 39, 
    height: 30, 
    cursor: 'pointer', 
    lineHeight: 1 
  };

  return (
    <div style={{ position: 'relative'}}>
      <button onClick={ChangeMonitoring} style={{ ...buttonStyle, fontSize: 25, lineHeight: 1.3, fontWeight: 'bold', position: 'absolute', top: 22, right: 80 }}>▷</button>
      <div style={{ position: 'absolute', top: 27, right: 140}}>
        <Toggle isToggled={autoChangeMonitoring} setIsToggled={setAutoChangeMonitoring} localStorageKey={toggleLocalStorageKey} />
      </div>
      {monitoringArray[monitoringIndex]}
    </div>
  );
}

export default JOFoodMonitoring;